import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

const services = [
  {
    number: 1,
    title: "Personal Training One to One",
    subtitle: "Personal Training One to One",
    desc: "Percorsi di allenamento affiancati dai nostri trainer, sviluppati in base alle specifiche esigenze della persona.Massima attenzione alla tecnica e alla progressione per risultati ottimali in sicurezza.",
    imageUrl: "/images/services/personal-training-one-to-one.webp"
  },
  {
    number: 2,
    title: "Personal Training One to Two",
    subtitle: "Personal Training One to Two",
    desc: "Percorsi di allenamento condivisi con un partner, mantenendo un alto livello di personalizzazione. Ideale per chi desidera motivazione reciproca senza rinunciare alla qualità del servizio.",
    imageUrl: "/images/services/personal-training-one-to-two.webp"
  },
  {
    number: 3,
    title: "Pilates Reformer One to One",
    subtitle: "Pilates Reformer One to One",
    desc: "Sedute individuali con macchinari Reformer Pilates, focalizzate su stabilità del core, forza e controllo del movimento. Un approccio mirato per il miglioramento globale del benessere fisico.",
    imageUrl: "/images/services/pilates-reformer-one-to-one.webp"
  },
  {
    number: 4,
    title: "Pilates Reformer One to Two",
    subtitle: "Pilates Reformer One to Two",
    desc: "Sessioni semi-private con l’ausilio del Reformer Pilates, pensate per due persone con obiettivi affini. Esercizi adattati alle esigenze di ciascun partecipante sotto guida esperta.",
    imageUrl: "/images/services/pilates-reformer-one-to-two.webp"
  },
  {
    number: 5,
    title: "Coaching",
    subtitle: "Coaching",
    desc: "Coaching su misura con programmi di allenamenti personalizzati, consigli su alimentazione, recupero e stile di vita; check periodici, sia online che dal vivo, e supporto costante per raggiungere i propri obiettivi.",
    imageUrl: "/images/services/coaching-online.webp"
  },
  {
    number: 6,
    title: "Fisioterapia",
    subtitle: "Fisioterapia",
    desc: "Interventi riabilitativi specifici per la prevenzione, diagnosi e trattamento di disfunzioni muscoloscheletriche. Proposte basate su terapia manuale ed esercizio terapeutico, per promuovere il movimento adattabile e gestire il dolore e le sue conseguenze.",
    imageUrl: "/images/services/fisioterapia.webp"
  },
  {
    number: 7,
    title: "Nutrizione",
    subtitle: "Nutrizione",
    desc: "Consulenze nutrizionali professionali orientate al miglioramento dello stato di salute e della composizione corporea. Piani alimentari personalizzati secondo obiettivi, abitudini e necessità cliniche.",
    imageUrl: "/images/services/nutrizione.webp"
  }
];

export function Services() {
  return `
    <section class="services" id="services-section">
      <div class="services__content">
        <div class="services__img-wrapper">
          <div class="services__img services__img--current"></div>
          <div class="services__img services__img--next"></div>
        </div>
        <div class="services__list">
          <div class="service__list-container">
            ${services.map((service, idx) => `
              <div class="service__container">
                <div class="service__header text-sm font-medium">
                  <p class="service__number">${service.number}.</p>
                  <p class="service__subtitle">${service.subtitle}</p>
                </div>
                ${service.title || service.desc ? `
                  <div class="service__content">
                    <h3 class="service__title text-xl font-medium">${service.title}</h3>
                    <p class="service__desc text-base font-medium">${service.desc}</p>
                  </div>
                ` : ''}
                ${idx < services.length - 1 ? '<div class="separator"></div>' : ''}
              </div>
            `).join('')}
          </div>
        </div>
      </div>
    </section>
  `;
}

export function animateServicesList() {
  const SCROLL_PER_STEP = 800;
  const section = document.querySelector('.services');
  const containers = Array.from(document.querySelectorAll('.service__container'));
  const currentImg = document.querySelector('.services__img--current');
  const nextImg = document.querySelector('.services__img--next');
  if (!containers.length || !section || !currentImg || !nextImg) return;

  // Inizializza: solo il primo è attivo e setta la prima immagine
  containers.forEach((container, i) => {
    container.classList.toggle('active', i === 0);
  });
  currentImg.style.backgroundImage = `url('${services[0].imageUrl}')`;
  currentImg.style.opacity = 1;
  nextImg.style.opacity = 0;

  let currentStep = 0;
  let isTransitioning = false;

  ScrollTrigger.create({
    trigger: section,
    start: 'top top',
    end: `+=${containers.length * SCROLL_PER_STEP}px`,
    pin: true,
    scrub: true,
    anticipatePin: 1,
    onUpdate: self => {
      const progress = self.progress;
      const step = Math.round(progress * (containers.length - 1));
      if (step !== currentStep && !isTransitioning) {
        isTransitioning = true;
        
        // Precarica la nuova immagine nell'elemento "next"
        const newImageUrl = services[step].imageUrl;
        nextImg.style.backgroundImage = `url('${newImageUrl}')`;
        
        // Verifica se l'immagine è già caricata
        const img = new Image();
        img.onload = () => {
          // Immagine caricata, procedi con la transizione
          gsap.to(currentImg, {
            opacity: 0,
            duration: 0.3,
            ease: 'power2.out'
          });
          
          gsap.to(nextImg, {
            opacity: 1,
            duration: 0.3,
            ease: 'power2.out',
            onComplete: () => {
              // Scambia i ruoli
              currentImg.style.backgroundImage = nextImg.style.backgroundImage;
              currentImg.style.opacity = 1;
              nextImg.style.opacity = 0;
              isTransitioning = false;
            }
          });
        };
        
        img.onerror = () => {
          // Se l'immagine non si carica, procedi comunque
          console.warn(`Failed to load image: ${newImageUrl}`);
          gsap.to(currentImg, {
            opacity: 0,
            duration: 0.3,
            ease: 'power2.out'
          });
          
          gsap.to(nextImg, {
            opacity: 1,
            duration: 0.3,
            ease: 'power2.out',
            onComplete: () => {
              currentImg.style.backgroundImage = nextImg.style.backgroundImage;
              currentImg.style.opacity = 1;
              nextImg.style.opacity = 0;
              isTransitioning = false;
            }
          });
        };
        
        img.src = newImageUrl;
        
        currentStep = step;
      }
      containers.forEach((container, i) => {
        container.classList.toggle('active', i === step);
      });
    }
  });
}